import React from "react";
import { useHistory } from "react-router-dom";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import AssessmentByGrade from "../../../templates/teacher/AssessmentByGrade";
import {
  Context,
  fetchAvgAssessmentByGrade,
  notFoundPath,
  updateAssessmentLastActive,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import useDebounceCallback from "../../../hooks/useDebounceCallback";
import useUpdateAssessmentLastActive from "../../../hooks/useUpdateAssessmentLastActive";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const grade = parseInt(parseQueryParams()["grade"]);
  const [calling, peep] = useWaitApiCall(state);
  const [loading, setLoading] = React.useState(calling);

  const grades = React.useMemo(
    () =>
      Array.from(
        new Map(
          state.teacher.classes.filter(c => !c.is_sub).map(c => [c.grade, c]),
        ).keys(),
      ),
    [state.teacher.classes],
  );

  const currentClass = React.useMemo(
    () =>
      state.teacher.classes.find(c => c.grade === grade && !c.is_sub) || {
        id: 0,
        name: "",
        grade: 0,
        charged: false,
        is_sub: false,
        full_name: "",
        assumed_entrance_year: 0,
      },
    [state.teacher.classes, grade],
  );

  React.useEffect(() => {
    if (grades.length && !grades.includes(Number(grade))) {
      history.push(notFoundPath);
    }
  }, [history, grades, grade]);

  useUpdateAssessmentLastActive(
    state.teacher.assessment_last_active_date ?? null,
    dispatch,
    updateAssessmentLastActive,
  );

  const [debounced] = useDebounceCallback(grade => {
    dispatch(peep(fetchAvgAssessmentByGrade(Number(grade))));
  }, 300);

  React.useEffect(() => {
    if (grade) {
      setLoading(true);
      debounced(grade);
    }
  }, [dispatch, debounced, peep, grade]);

  React.useEffect(() => {
    if (!calling) {
      setLoading(false);
    }
  }, [calling]);

  return (
    <AssessmentByGrade
      calling={loading}
      currentClass={currentClass}
      grades={grades}
      avgScoresData={state.assessment_avg_scores_by_grade}
      previousAvgScoresData={
        state.past_assessment_avg_scores_by_grade.previous_assessment_avg_scores
      }
      firstAvgScoresData={
        state.past_assessment_avg_scores_by_grade.first_assessment_avg_scores
      }
    />
  );
};
